"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Flag = void 0;

var tslib_1 = require("tslib");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var ui_symbols_1 = require("@hopin-team/ui-symbols");

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

var flag_1 = require("../partials/flag");

exports.Flag = (0, ui_helper_with_space_1.withSpace)((0, styled_components_1.default)(flag_1.Flag)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  width: ", ";\n"], ["\n  width: ", ";\n"])), (0, ui_symbols_1.calcSpace)(3)));
var templateObject_1;